module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Part One")]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_c('i', [_vm._v("Designer Genes")])]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("He who only sees fashion in fashion is nothing but a fool.")]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONORÉ DE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALZAC")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148a8300","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/07_part01.vue
// module id = 69
// module chunks = 0